/*
 * @ Author: Housefolios
 * @ Create Time: 2021-12-16 11:36:56
 * @ Modified by: David Helmick
 * @ Modified time: 2025-12-05 15:53:28
 * @ Description: Page that shows when logging in without a active org. Includes options to signup for a free account
 */

import React, { useState } from 'react'
// Centralized lodash imports - much cleaner!
import { toLower, upperFirst } from '@/utils/lodash'
import { GET_ME } from '../../Session/queries'

import {
  Button,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  Box,
} from '@mui/material'

import particles2 from '@/assets/images/hero-bg/particles-2.svg'
import deactivatedImage from '@/assets/images/DeactivatedImage.png'
import { enqueueSnackbar } from 'notistack'
import CreateNewOrg from '@/housefolios-components/OrganizationSettings/CreateNewOrg'
import { ApolloConsumer } from '@/components/ApolloConsumer'
import { useMutation } from '@apollo/client/react'
import { signOut } from '@/housefolios-components/SignOut'
import withSession from '@/housefolios-components/Session/withSession'
import { CREATE_ORGANIZATION } from '@/housefolios-components/OrganizationSettings/mutations'
import BlockUi from 'react-block-ui'
import { PacmanLoader } from 'react-spinners'
import ContactSupport from '@/housefolios-components/Dialogs/ContactSupport'

function DeactivatedPageComponent(props) {
  const { session } = props
  const { email } = session.me
  const [openCreateFreeAccount, setOpenCreateFreeAccount] =
    useState(false)
  const [supportOpen, setSupportOpen] = useState(false)

  const handleOpenCreateFreeAccount = () => {
    setOpenCreateFreeAccount(true)
  }
  const handleCloseCreateFreeAccount = () => {
    setOpenCreateFreeAccount(false)
  }

  const queryString = window.location.search
  const urlParams = new URLSearchParams(queryString)
  let hfpid = urlParams.get('hfpid')

  // Block free account creation for specific partners and domains
  const blockedHfpids = ['pacemorby', 'astroflip', 'pep']
  const hostname = window.location.hostname || ''
  const isBlockedDomain =
    hostname === 'dealsauce.io' ||
    hostname === 'propertyedge.pro' ||
    hostname.endsWith('.dealsauce.io') ||
    hostname.endsWith('.propertyedge.pro')
  const isBlockedHfpid = hfpid
    ? blockedHfpids.includes(toLower(hfpid))
    : false
  const isFreeBlocked = isBlockedDomain || isBlockedHfpid

  const [loader, setLoader] = useState(false)

  const [createOrganization] = useMutation(CREATE_ORGANIZATION)

  const handleSubmit = async () => {
    if (isFreeBlocked) {
      enqueueSnackbar(
        'Free accounts are not available for this partner.',
        {
          variant: 'warning',
        },
      )
      setLoader(false)
      return
    }
    setLoader(true)
    const productChoice = 'free'
    const planPrice = 0
    const planID = 'free'
    let gaID = hfpid
      ? upperFirst(productChoice) +
        '_' +
        hfpid.toString() +
        '_' +
        email
      : productChoice + '_' + email

    createOrganization({
      variables: {
        organizationInput: {
          name:
            session.me.profile.firstname +
            session.me.profile.lastname,
          email: toLower(session.me.email),
        },
        freeAccount: true,
      },
      refetchQueries: [
        {
          query: GET_ME,
        },
      ],
    })
      .then(async ({ data  }) => {
        localStorage.setItem(
          `buyBox-${data.createOrganization.orgId}`,
          'true',
        )
        localStorage.setItem('token', data.createOrganization.token)
        //await props.refetch()
        // props.history.push('/launchpad')
        window.location.reload()
        setLoader(false)
        //this.props.history.push(routes.MARKETPLACE + 'card')
      })
      .catch((error) => {
        console.log('"' + error.message + '"')
        // if (element) element.clear()
        setLoader(false)
      })
  }
  return (
    <>
      {/* <ListItem button onClick={handleOpenEditPortfolio} selected>
        <AttachFileOutlinedIcon />
        Test3
      </ListItem>
      <Dialog
        open={openEditPortfolio}
        onClose={handleCloseEditPortfolio}
        maxWidth="xl"
        fullWidth={true}
      > */}
      <div style={{flexGrow:1,display:"flex",zIndex:6,width:"100%",alignItems:"center"}}>
        <Box style={{ backgroundImage: 'url(' + particles2 + ')' }} sx={{
          position: "absolute",
          left: 0,
          top: 0,
          height: "100%",
          width: "100%",
          zIndex: 3,
          opacity: "0.7 !important",
          filter: "grayscale(0%)",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center center",
          borderTopLeftRadius: "inherit",
          borderTopRightRadius: "inherit",
        }} />
        <Box sx={{ position: "relative", zIndex: "7", width: "100%" }}>
          <Box sx={{
            "@media (min-width: 1440px)": { py: "3rem" },
            py: "1rem",
          }}>
            <Container sx={[{ py: '3rem' }, {
              color: "#070919",
              "html[data-color-mode=\"dark\"] &": { color: "rgba(255, 255, 255, 0.87) !important" },
            }]}>
              <Grid container spacing={6}>
                <Grid
                  size={{
                    xl: 6,
                  }}
                  sx={{ display: 'flex', alignItems: 'center' }}
                >
                  <div>
                    <Box
                      sx={{ display: 'flex', alignItems: 'center' }}
                    >
                      <Box
                       
                        sx={{
                          display: "inline-block",
                          py: "0.25rem",
                          px: "1.5rem",
                          fontSize: "70%",
                          fontWeight: 700,
                          lineHeight: "21px",
                          textAlign: "center",
                          whiteSpace: "nowrap",
                          verticalAlign: "baseline",
                          borderRadius: "0.65rem",
                          textTransform: "uppercase",
                          height: "auto",
                          pr: "0.85em",
                          pl: "0.85em",
                          color: "#fff",
                          backgroundColor: "#1bc943",
                        }}
                      >
                        ACCOUNT NOT ACTIVE
                      </Box>
                    </Box>
                    <Box sx={[{ mt: '1rem' }, {
                      color: "#070919",
                      "html[data-color-mode=\"dark\"] &": { color: "rgba(255, 255, 255, 0.87) !important" },
                    }]}>
                      <Box component="h1" sx={[{ mb: '1rem', fontWeight: 700 }, { fontSize: "3rem", fontWeight: "300", lineHeight: "1.2" }]}>
                        You aren't tied to an active organization.
                      </Box>
                      <Box component="p" sx={[{ color: 'rgba(7, 9, 25, 0.5)' }, { fontSize: "1.15rem !important" }]}>
                        This occurs when you've canceled your account
                        or been removed as a team member of an active
                        organization.
                      </Box>
                      <Box
                        component="p"
                        sx={{ color: 'rgba(7, 9, 25, 0.5)' }}
                      >
                        If this is an error, contact your Org Creator.
                        If you are the Org Creator then message our
                        support team
                      </Box>
                      <Box sx={[{ my: '1.5rem', borderRadius: '50%', width: '25%', }, { borderWidth: "2px !important", borderStyle: "solid !important", opacity: "0.2 !important" }, { background: "#eeeff8", height: "1px", overflow: "hidden" }]} style={{ borderColor: '#f4f5fd' }} />
                      <div>
                        {isFreeBlocked ? (
                          <Button
                            href={null}
                            onClick={() => setSupportOpen(true)}
                            size="large"
                           
                            sx={{
                              boxShadow: "0 0.25rem 0.55rem rgba(65, 145, 255, 0.35)",
                              color: "#fff",
                              backgroundColor: "#4191ff",
                              backgroundImage: "none",
                              borderColor: "#4191ff",
                              "&:not(:disabled):hover": { backgroundColor: "#4191ff", color: "#fff" },
                              "&:not(:disabled).active, &:not(:disabled).active:hover, &:not(:disabled):active": { backgroundColor: "#0e73ff" },
                              "&:not(:disabled):active": { boxShadow: "0 0.22rem 0.525rem rgba(65, 145, 255, 0.4), 0 0.0625rem 0.385rem rgba(65, 145, 255, 0.54)" },
                              "&:not(:disabled).active .btn-wrapper--icon svg path, &:hover .btn-wrapper--icon svg path": { fill: "#fff" },
                              "@media (min-width: 576px)": { display: "inline-block" },
                              display: "block",
                            }}
                          >
                            <Box component="span" sx={{
                              display: "inline-block",
                              "&:not(:first-of-type)": { ml: "0.5rem", marginLeft: "0.5rem" },
                              "& + .btn-wrapper--icon": { ml: "0.5rem", marginLeft: "0.5rem" },
                            }}>
                              Contact support
                            </Box>
                          </Button>
                        ) : (
                          <CreateNewOrg deactive={true} />
                        )}
                        <ApolloConsumer>
                          {(client) => (
                            <Button
                              href={null}
                              onClick={
                                isFreeBlocked
                                  ? () =>
                                      signOut(
                                        client,
                                        props?.session?.me?.activeOrg
                                          ?.member,
                                      )
                                  : handleOpenCreateFreeAccount
                              }
                              // onClick={() => signOut(client, props.history, props?.session?.me?.activeOrg?.member)}
                              size="large"
                              variant="text"
                             
                              sx={{
                                backgroundColor: "transparent",
                                color: "#4191ff",
                                border: "#4191ff solid 2px",
                                "&:not(:disabled):hover": { boxShadow: "0 0.22rem 0.525rem rgba(65, 145, 255, 0.4), 0 0.0625rem 0.385rem rgba(65, 145, 255, 0.54)", backgroundColor: "#4191ff", color: "#fff" },
                                "&:not(:disabled).active, &:hover": { backgroundColor: "#4191ff", color: "#fff" },
                                "@media (min-width: 576px)": { display: "inline-block", mt: 0, ml: "1rem" },
                                display: "block",
                                ml: 0,
                                mt: "1rem",
                              }}
                            >
                              <span>Sign Out</span>
                            </Button>
                          )}
                        </ApolloConsumer>
                      </div>
                    </Box>
                  </div>
                </Grid>
                <Grid
                 
                  size={{
                    xl: 6,
                  }}
                  sx={[{
                    "@media (min-width: 1440px)": { display: "flex" },
                  }, {
                    px: 0,
                    display: 'none',
                    alignItems: 'center',
                  }]}
                >
                  <Box
                    component="img"
                    src={deactivatedImage}

                    alt="..."
                    sx={{
                      width: '100%',
                      mx: 'auto',
                      display: 'block',
                      maxWidth: '100%',
                      height: 'auto',
                    }}
                  />
                </Grid>
              </Grid>
            </Container>
          </Box>
        </Box>
      </div>
      {!isFreeBlocked && (
        <Dialog
          open={openCreateFreeAccount}
          onClose={handleCloseCreateFreeAccount}
          maxWidth="xs"
          fullWidth={true}
        >
          <BlockUi
            blocking={loader}
            loader={
              <PacmanLoader color={'var(--primary)'} loading={true} />
            }
            message={
              <Box sx={{ color: '#368cff' }}>
                Changing Account Type
              </Box>
            }
          >
            {/* <DialogTitle>Test</DialogTitle> */}
            <DialogContent>
              Before you leave sign up for a free account!
            </DialogContent>
            <DialogActions>
              <ApolloConsumer>
                {(client) => (
                  <>
                    <Button
                      size="small"
                      variant="outlined"
                      onClick={() =>
                        signOut(
                          client,
                          props?.session?.me?.activeOrg?.member,
                        )
                      }
                    >
                      Sign Out
                    </Button>

                    <Button
                      size="small"
                      variant="contained"
                      color="primary"
                      onClick={() => handleSubmit()}
                    >
                      Free Account
                    </Button>
                  </>
                )}
              </ApolloConsumer>
            </DialogActions>
          </BlockUi>
        </Dialog>
      )}
      {isFreeBlocked && (
        <ContactSupport
          open={supportOpen}
          handleClose={() => setSupportOpen(false)}
          affiliate={props?.session?.me?.activeOrg?.member}
          dealsauceStripeCustomerID={
            props?.session?.me?.activeOrg?.dealsauceStripeCustomerID
          }
          goHighLevelId={props?.session?.me?.activeOrg?.goHighLevelId}
          session={props.session}
        />
      )}
      {/* </Dialog> */}
    </>
  )
}

export default withSession(DeactivatedPageComponent)
